/* ⚠️ GENERATED from app/services/groupMembers.ts by gen-twins.mjs — edit the TypeScript, not this. */
// services/groupMembers.ts — who is in a group, in the order the group holds them.
//
// 🟥 THREE PLACES ANSWERED THIS AND TWO OF THEM WERE WRONG. GroupCollageAvatar
//    took `participants` minus `leftParticipants`; the browser's Avatar filtered
//    the CURRENT USER out and ignored the leavers entirely — so the same group
//    wore a two-tile picture in one client and a three-tile one in the other, and
//    somebody who had left still had a face on the web.
//
// 🟢 AND NOW A FOURTH PLACE NEEDS IT: tapping a group with no photo pages through
//    its members. The pager and the collage have to agree about who is in the
//    group and in what order, or "1 of 4" counts different people than the four
//    tiles you just tapped.

/** Everybody still in the group, in the group's own order. */
export function activeMembers(chat) {
  const left = Array.isArray(chat?.leftParticipants) ? chat.leftParticipants : [];
  const seen = new Set();
  return (Array.isArray(chat?.participants) ? chat.participants : []).filter(uid => {
    if (!uid || typeof uid !== 'string') return false;
    if (left.includes(uid)) return false;
    /* 🟢 A DUPLICATE IS ONE PERSON. `arrayUnion` cannot produce one, but a
       hand-repaired document and an old migration both can, and a repeated uid
       would give the same member two tiles and inflate the counter. */
    if (seen.has(uid)) return false;
    seen.add(uid);
    return true;
  });
}

/** How many tiles a collage draws. The pager shows everybody; the collage does not. */
export const COLLAGE_MAX = 4;

/**
 * A member's picture, from what the chat document already knows.
 *
 * 🟢 THE LIVE COPY OF MY OWN PHOTO WINS. `participantImages` is a cache frozen at
 *    the time somebody wrote it, so after changing my own picture I would go on
 *    seeing the old one in my own groups — the one member whose current photo is
 *    always in hand.
 *
 * 🟥 AND A PHONE-LOCAL PATH IS NOT A PICTURE. `file://`, `content://` and `ph://`
 *    are what a phone writes into that map; they render as nothing on another
 *    device and as a broken tile in a browser.
 */
export function memberPhoto(chat, uid, opts) {
  const my = String(opts?.myUid || '').trim();
  if (my && uid === my && opts?.myPhoto) return webSafePhoto(opts.myPhoto);
  const fromMap = chat?.participantImages?.[uid];
  const mapped = webSafePhoto(fromMap);
  if (mapped) return mapped;
  return webSafePhoto(opts?.fetched?.[uid]) || null;
}

/** Only a url another device can actually open. */
export function webSafePhoto(u) {
  if (!u || typeof u !== 'string') return null;
  const s = u.trim();
  if (!s) return null;
  return /^https?:\/\//i.test(s) || s.startsWith('data:') ? s : null;
}

/** The member's name for a tile or a caption, from the chat's own cache. */
export function memberName(chat, uid, fallback = '') {
  const n = chat?.participantNames?.[uid];
  return typeof n === 'string' && n.trim() ? n.trim() : fallback;
}

/* 🔐 WHOM A MESSAGE IN THIS CHAT IS SEALED FOR. 🟥 Every web sender sealed for `participants`, which
      never shrinks — a member who left or was removed kept getting every new message encrypted for
      their devices. 🟢 A group's ACTIVE members; a 1-on-1's two people. (The app's senders use
      services/groupSealSet, which also weighs the live list against the row's.) */
export function sealMembers(chat) {
  if (!chat || !chat.isGroup) return Array.isArray(chat && chat.participants) ? chat.participants : [];
  return activeMembers(chat);
}
